module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp2-01-128632ec36ba2b99788a0bfabbb16f10.png";